import { useEffect, useState } from 'react';
import { useModal } from '../../components/ModalProvider';
import { managerApi } from '../../lib/api';
import { errorMessage } from '../../components/ErrorModalBody';

const emptyForm = {
  nome: '', funcao: '', cpf: '', pis: '', telefone: '', pix: '', endereco: '', camarote: '', valorHora: '', recebeEpi: false, turno: 'diurno',
  hEntrada: '14:00', hSaidaDesc: '19:00', hVoltaDesc: '20:00', hSaida: '23:30',
};

export function FuncionariosTab() {
  const { showModal, closeModal } = useModal();
  const [employees, setEmployees] = useState<any[]>([]);
  const [camarotes, setCamarotes] = useState<string[]>([]);
  const [tipoHorario, setTipoHorario] = useState('esperado');
  const [form, setForm] = useState({ ...emptyForm });
  const [loading, setLoading] = useState(true);

  async function reload() {
    const [emp, cfg] = await Promise.all([managerApi.listEmployees(), managerApi.getConfig()]);
    setEmployees(emp.employees);
    setCamarotes(cfg.config.camarotes);
    setTipoHorario(cfg.config.tipoHorario);
    if (!form.camarote && cfg.config.camarotes.length) setForm((f) => ({ ...f, camarote: cfg.config.camarotes[0] }));
  }
  useEffect(() => { setLoading(true); reload().finally(() => setLoading(false)); }, []);

  async function addEmployee() {
    if (!form.nome.trim() || !form.funcao.trim()) { alert('Preencha ao menos nome e função.'); return; }
    await managerApi.addEmployee({
      nome: form.nome.trim(), funcao: form.funcao.trim(), cpf: form.cpf.trim(), pis: form.pis.trim(),
      telefone: form.telefone.trim(), pix: form.pix.trim(), endereco: form.endereco.trim(), camarote: form.camarote,
      valorHora: form.valorHora.trim(), recebeEpi: form.recebeEpi, turno: tipoHorario === 'turno' ? form.turno : null,
      horarios: { entrada: form.hEntrada, saida_descanso: form.hSaidaDesc, volta_descanso: form.hVoltaDesc, saida: form.hSaida },
    });
    setForm({ ...emptyForm, camarote: camarotes[0] || '' });
    await reload();
  }

  async function toggleEmp(id: string) {
    await managerApi.toggleEmployee(id);
    await reload();
  }

  async function sendLogin(emp: any) {
    if (!emp.telefone) { alert('Este funcionário não tem telefone cadastrado.'); return; }
    try {
      const res = await managerApi.sendEmployeeLogin(emp.id);
      alert(res.sucesso ? 'Enviado!' : `Não enviado: ${res.detalhe}`);
    } catch (err) {
      alert(errorMessage(err));
    }
  }

  function sendNotificationModal(emp: any) {
    const Body = () => {
      const [mensagem, setMensagem] = useState('');
      const [busy, setBusy] = useState(false);
      const [err, setErr] = useState('');
      async function enviar() {
        if (!mensagem.trim()) { setErr('Escreva a mensagem.'); return; }
        setBusy(true);
        setErr('');
        try {
          const res = await managerApi.sendPushBroadcast([emp.id], mensagem.trim());
          const r = res.results[0];
          if (r?.sucesso) { closeModal(); alert('Notificação enviada!'); }
          else setErr(r?.detalhe || 'Não foi possível enviar.');
        } catch (e) {
          setErr(errorMessage(e));
        } finally {
          setBusy(false);
        }
      }
      return (
        <>
          <h2>Enviar notificação — {emp.nome}</h2>
          <p className="hint">Manda uma notificação do navegador para este funcionário (só funciona se ele já tiver ativado notificações).</p>
          <label>Mensagem</label>
          <textarea placeholder="Escreva o aviso..." value={mensagem} onChange={(e) => setMensagem(e.target.value)} />
          {err && <div className="err">{err}</div>}
          <div className="row" style={{ marginTop: 14 }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" style={{ flex: 1 }} disabled={busy} onClick={enviar}>Enviar</button>
          </div>
        </>
      );
    };
    showModal(<Body />);
  }

  function editEmpModal(emp: any) {
    const EditBody = () => {
      const [f, setF] = useState({
        nome: emp.nome, funcao: emp.funcao, cpf: emp.cpf || '', pis: emp.pis || '', telefone: emp.telefone || '', pix: emp.pix || '',
        endereco: emp.endereco || '', camarote: emp.camarote, valorHora: emp.valorHora || '', recebeEpi: emp.recebeEpi, pin: emp.pin,
        turno: emp.turno || 'diurno', ativo: emp.ativo,
        hEntrada: emp.horarios?.entrada || '', hSaidaDesc: emp.horarios?.saida_descanso || '', hVoltaDesc: emp.horarios?.volta_descanso || '', hSaida: emp.horarios?.saida || '',
      });
      async function save() {
        await managerApi.updateEmployee({
          id: emp.id, nome: f.nome.trim(), funcao: f.funcao.trim(), cpf: f.cpf.trim(), pis: f.pis.trim(), telefone: f.telefone.trim(),
          pix: f.pix.trim(), endereco: f.endereco.trim(), camarote: f.camarote, valorHora: f.valorHora.trim(), recebeEpi: f.recebeEpi,
          pin: f.pin.trim(), turno: tipoHorario === 'turno' ? f.turno : null, ativo: f.ativo,
          horarios: { entrada: f.hEntrada, saida_descanso: f.hSaidaDesc, volta_descanso: f.hVoltaDesc, saida: f.hSaida },
        });
        closeModal();
        await reload();
      }
      return (
        <>
          <h2>Editar {emp.nome}</h2>
          <label>Nome</label><input type="text" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} />
          <label>Função</label><input type="text" value={f.funcao} onChange={(e) => setF({ ...f, funcao: e.target.value })} />
          <div className="row">
            <div className="col"><label>CPF</label><input type="text" value={f.cpf} onChange={(e) => setF({ ...f, cpf: e.target.value })} /></div>
            <div className="col"><label>PIS</label><input type="text" value={f.pis} onChange={(e) => setF({ ...f, pis: e.target.value })} /></div>
          </div>
          <div className="row">
            <div className="col"><label>Telefone</label><input type="text" value={f.telefone} onChange={(e) => setF({ ...f, telefone: e.target.value })} /></div>
            <div className="col"><label>PIX</label><input type="text" value={f.pix} onChange={(e) => setF({ ...f, pix: e.target.value })} /></div>
          </div>
          <label>Endereço</label><input type="text" value={f.endereco} onChange={(e) => setF({ ...f, endereco: e.target.value })} />
          <div className="row">
            <div className="col"><label>Camarote</label>
              <select value={f.camarote} onChange={(e) => setF({ ...f, camarote: e.target.value })}>
                {camarotes.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div className="col"><label>Valor por hora (R$)</label><input type="text" value={f.valorHora} onChange={(e) => setF({ ...f, valorHora: e.target.value })} /></div>
          </div>
          <label className="checkrow"><input type="checkbox" checked={f.recebeEpi} onChange={(e) => setF({ ...f, recebeEpi: e.target.checked })} /> Este funcionário recebe registro de EPI</label>
          <div className="row">
            <div className="col"><label>Situação</label>
              <select value={f.ativo ? 'ativo' : 'inativo'} onChange={(e) => setF({ ...f, ativo: e.target.value === 'ativo' })}>
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
            {tipoHorario === 'turno' && (
              <div className="col"><label>Turno</label>
                <select value={f.turno} onChange={(e) => setF({ ...f, turno: e.target.value })}>
                  <option value="diurno">Diurno</option>
                  <option value="noturno">Noturno</option>
                </select>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col"><label>Entrada</label><input type="time" value={f.hEntrada} onChange={(e) => setF({ ...f, hEntrada: e.target.value })} /></div>
            <div className="col"><label>Saída descanso</label><input type="time" value={f.hSaidaDesc} onChange={(e) => setF({ ...f, hSaidaDesc: e.target.value })} /></div>
          </div>
          <div className="row">
            <div className="col"><label>Volta descanso</label><input type="time" value={f.hVoltaDesc} onChange={(e) => setF({ ...f, hVoltaDesc: e.target.value })} /></div>
            <div className="col"><label>Saída</label><input type="time" value={f.hSaida} onChange={(e) => setF({ ...f, hSaida: e.target.value })} /></div>
          </div>
          <label>PIN</label><input type="text" maxLength={4} value={f.pin} onChange={(e) => setF({ ...f, pin: e.target.value })} />
          <div className="row" style={{ marginTop: 14 }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={closeModal}>Cancelar</button>
            <button className="btn btn-primary" style={{ flex: 1 }} onClick={save}>Salvar</button>
          </div>
        </>
      );
    };
    showModal(<EditBody />);
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <h2>Novo funcionário</h2>
        <p className="hint">Dados da planilha — usados para preencher os documentos automaticamente.</p>
        <div className="row">
          <div className="col"><label>Nome completo</label><input type="text" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></div>
          <div className="col"><label>Função</label><input type="text" placeholder="Garçom, segurança..." value={form.funcao} onChange={(e) => setForm({ ...form, funcao: e.target.value })} /></div>
        </div>
        <div className="row">
          <div className="col"><label>CPF</label><input type="text" placeholder="000.000.000-00" value={form.cpf} onChange={(e) => setForm({ ...form, cpf: e.target.value })} /></div>
          <div className="col"><label>PIS</label><input type="text" placeholder="000.00000.00-0" value={form.pis} onChange={(e) => setForm({ ...form, pis: e.target.value })} /></div>
        </div>
        <div className="row">
          <div className="col"><label>Telefone</label><input type="text" placeholder="(71) 90000-0000" value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} /></div>
          <div className="col"><label>PIX</label><input type="text" placeholder="chave PIX" value={form.pix} onChange={(e) => setForm({ ...form, pix: e.target.value })} /></div>
        </div>
        <label>Endereço completo</label><input type="text" placeholder="Rua, número, bairro, cidade, CEP" value={form.endereco} onChange={(e) => setForm({ ...form, endereco: e.target.value })} />
        <div className="row">
          <div className="col"><label>Camarote</label>
            <select value={form.camarote} onChange={(e) => setForm({ ...form, camarote: e.target.value })}>
              {camarotes.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="col"><label>Valor por hora (R$)</label><input type="text" placeholder="ex: 15,00" value={form.valorHora} onChange={(e) => setForm({ ...form, valorHora: e.target.value })} /></div>
        </div>
        <label className="checkrow"><input type="checkbox" checked={form.recebeEpi} onChange={(e) => setForm({ ...form, recebeEpi: e.target.checked })} /> Este funcionário recebe registro de EPI</label>
        {tipoHorario === 'turno' && (
          <><label>Turno</label>
          <select value={form.turno} onChange={(e) => setForm({ ...form, turno: e.target.value })}>
            <option value="diurno">Diurno</option>
            <option value="noturno">Noturno</option>
          </select></>
        )}
        <hr className="div" />
        <p className="hint" style={{ marginBottom: 6 }}>Horários esperados (a tolerância configurada se aplica a cada um)</p>
        <div className="row">
          <div className="col"><label>Entrada</label><input type="time" value={form.hEntrada} onChange={(e) => setForm({ ...form, hEntrada: e.target.value })} /></div>
          <div className="col"><label>Saída descanso</label><input type="time" value={form.hSaidaDesc} onChange={(e) => setForm({ ...form, hSaidaDesc: e.target.value })} /></div>
        </div>
        <div className="row">
          <div className="col"><label>Volta descanso</label><input type="time" value={form.hVoltaDesc} onChange={(e) => setForm({ ...form, hVoltaDesc: e.target.value })} /></div>
          <div className="col"><label>Saída</label><input type="time" value={form.hSaida} onChange={(e) => setForm({ ...form, hSaida: e.target.value })} /></div>
        </div>
        <button className="btn btn-primary btn-block" style={{ marginTop: 16 }} onClick={addEmployee}>Cadastrar funcionário</button>
      </div>
      <div className="card">
        <h2>Equipe ({employees.length})</h2>
        {employees.length === 0 && <p className="hint">Nenhum funcionário cadastrado ainda.</p>}
        {employees.map((e) => (
          <div className="card" style={{ padding: '14px 16px', marginBottom: 10 }} key={e.id}>
            <div className="toolbar">
              <div>
                <div style={{ fontWeight: 700 }}>
                  {e.nome} {!e.ativo && <span className="pill pill-off">inativo</span>} {e.recebeEpi && <span className="pill pill-tag">EPI</span>} {e.consentAceito ? <span className="pill pill-ok">termo aceito</span> : <span className="pill pill-pending">termo pendente</span>}
                </div>
                <div className="muted">{e.funcao} · {e.camarote} · CPF {e.cpf || '—'}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className="copy-pin">{e.pin}</span>
                <button className="btn btn-ghost btn-sm" onClick={() => sendLogin(e)}>Enviar SMS/WhatsApp</button>
                <button className="btn btn-ghost btn-sm" onClick={() => sendNotificationModal(e)}>Enviar notificação</button>
                <button className="btn btn-ghost btn-sm" onClick={() => editEmpModal(e)}>Editar</button>
                <button className="btn btn-danger btn-sm" onClick={() => toggleEmp(e.id)}>{e.ativo ? 'Desativar' : 'Reativar'}</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
